var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.91c-1.2.14-1.91-.28-2 .25a.33.33 0 0 0 .28.38 7.62 7.62 0 0 0 2.08.3 1.55 1.55 0 0 0 1.26-2.31 1.9 1.9 0 0 0-1.49-.78h-1.7a.29.29 0 0 0-.1.58c1.8.36 2.1.33 2.35.77.08.15.05.33-.11.57s-.32.21-.57.24Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.15 13.81a5 5 0 0 1 1.44.06.29.29 0 0 0 .17-.56c-1.18-.5-2.78-.71-3.49.36-.89 1.32.89 2.68 3 2.15a.33.33 0 0 0-.11-.66c-1.12.1-2.29-.54-1.84-1a1.45 1.45 0 0 1 .83-.35Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.78a.33.33 0 0 0-.65.11c.58 4-.55 4.27-2.62 4.15-10.51-.4-10.84-.29-11.08-1a4.38 4.38 0 0 1 0-1.92c.38-2.32 1-1.9 2-2.67a27.41 27.41 0 0 0 9 .17.34.34 0 0 0 0-.67c-.63 0-1.83-.06-3.17-.12-2.86-.11-3.83.05-5.32 0C8.69 10 8.71 8.64 9.33 8s2-.18 4.3-.72a.29.29 0 0 0-.13-.57c-3 .6-4.44-.43-5.34 1.7-.37.86-.41 1.91-1.17 2.38-.93.58-1.92.52-2.42 3.16a5.32 5.32 0 0 0 0 2.47 2 2 0 0 0 1.76 1.28 4.76 4.76 0 0 0-.06 1 2 2 0 0 0 1.42 1.76A2 2 0 0 0 10.16 18a.3.3 0 0 0-.05-.16l4.18.05a2.86 2.86 0 0 0 .64 1.77c1.69 1.7 3.61.33 3.7-1.91 0-.09-.06 0 .12-.09 1.76-.66 1.6-2.97 1.25-4.88ZM9.5 18a1.24 1.24 0 0 1-2.45.36 4.78 4.78 0 0 1-.05-.59c3.13.23 2.49-.14 2.5.23Zm7.5 1.21a1.19 1.19 0 0 1-1.36-.27 1.93 1.93 0 0 1-.65-1 26 26 0 0 0 2.93 0 2.34 2.34 0 0 1-.92 1.27Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.91 6.92c-.71-.49-1.86-.24-2.75-.11a.3.3 0 0 0-.28.32c0 .45.61.17 1.76.34.61.08.83.28 1 1s.25 1.67.59 2.54 1 1 1.61 1.39a.33.33 0 1 0 .44-.49c-.43-.44-1-.66-1.17-1.19-.17-.89.06-2.94-1.2-3.8Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.17 6.38a.34.34 0 0 0-.47 0c-.49.6 1.27.76 2.29 3.8a11 11 0 0 1-.57 7.82c-2.05 4.68-9.64 6-14.21 3.94A8 8 0 0 1 3 18c-3.49-6.52.64-13.14 6.6-14.66.59-.12.53-.64.1-.65A11.11 11.11 0 0 0 .77 14.23 11 11 0 0 0 4.92 22c5.73 4 15.11 1.8 17.34-3.6 1.74-4.19 1.37-9.22-2.09-12.02Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.27 5.7c.82-.16 1.46-.31 1.55-1.1a1.81 1.81 0 0 0 .82 0l.77-.28a.34.34 0 0 0 .05-.67 5.55 5.55 0 0 0-1.59-.1c-.14 0-.13.08-.14 0-.05-.5-.12-1-.17-1.52a2.74 2.74 0 0 0 2-.17.33.33 0 0 0-.06-.66 3.57 3.57 0 0 0-2 0c-.07-1.19-1.56-1.3-2.74-1-3.95.71-3.17 6.3 1.51 5.5Zm-2.63-4a3.17 3.17 0 0 1 2.92-.9.34.34 0 0 0 .32-.06l0 3.79-.76.12c-1 .14-2.08 0-2.49-.91a2.28 2.28 0 0 1 .01-2.08Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricVehicles);
export default __webpack_public_path__ + "static/media/electric-vehicles.93c6bf5602d341b4a983e64656e14c1f.svg";
export { ForwardRef as ReactComponent };